import { render, staticRenderFns } from "./block1.vue?vue&type=template&id=94cb2e62&scoped=true&"
import script from "./block1.vue?vue&type=script&lang=js&"
export * from "./block1.vue?vue&type=script&lang=js&"
import style0 from "./block1.vue?vue&type=style&index=0&id=94cb2e62&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cb2e62",
  null
  
)

export default component.exports